/*! npm.im/supports-webp 1.0.7 */
'use strict';

var canvas = typeof document === 'object' ? document.createElement('canvas') : {};
canvas.width = canvas.height = 1;
var index = canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;

module.exports = index;



// WEBPACK FOOTER //
// ../supports-webp/dist/supports-webp.common-js.js